import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/Models/user';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { Roles } from 'app/core/Enums/Roles';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
    static ngAcceptInputType_showAvatar: BooleanInput;

    @Input() showAvatar: boolean = true;
    user: User;
    showRoleSelection: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _authService: AuthService,
    ) { }

    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                this.showRoleSelection = false;
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    changeMainRole(mainRole: Roles) {
        this._authService.changeMainRole(mainRole).subscribe(() => {
            location.href = "/";
        });
    }

    toggleRoleSelection(): void {
        this.showRoleSelection = !this.showRoleSelection;
        this._changeDetectorRef.markForCheck();
    }

    // ChooseMainPosition(mainPositionId: string) {
    //     this._authService
    //         .chooseMainPosition(mainPositionId)
    //         .subscribe((x) => {
    //             location.href = "/";
    //         });
    // }

    navigateToProfilePage() {
        this._router.navigate(['/pages/profile']);
    }
}
